import { render } from "./SpaStart.vue?vue&type=template&id=6201704e"
import script from "./SpaStart.vue?vue&type=script&lang=js"
export * from "./SpaStart.vue?vue&type=script&lang=js"

import "./SpaStart.vue?vue&type=style&index=0&id=6201704e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__